import { ReactNode } from 'react';

export interface BadgeProps {
	content: ReactNode;
	size?: 'xs' | 'sm' | 'md' | 'lg';
	color?:
		| 'gray'
		| 'red'
		| 'yellow'
		| 'green'
		| 'blue'
		| 'indigo'
		| 'purple'
		| 'pink'
		| 'orange'
		| 'teal'
		| 'cyan'
		| 'emerald'
		| 'lime'
		| 'rose'
		| 'sky'
		| 'violet'
		| 'fuchsia'
		| 'amber'
		| 'stone'
		| 'neutral'
		| 'zinc'
		| 'slate';
}

export function Badge(props: BadgeProps) {
	// Set button styles
	let buttonStyles = '';

	if (props.color) {
		buttonStyles = `text-${props.color}-600 bg-${props.color}-50 border border-${props.color}-400 hover:bg-${props.color}-100 focus:ring-${props.color}-200`;
	} else {
		buttonStyles =
			'text-gray-600 bg-gray-50 border border-gray-400 hover:bg-gray-100 focus:ring-gray-200';
	}

	return (
		<span
			className={`inline-flex items-center rounded px-2 py-0.5 text-${props.size || 'xs'} font-medium ${buttonStyles}`}
		>
			{props.content}
		</span>
	);
}

export default Badge;
